/**
 * @fileoverview Aba Perfis de acesso de Equipe e permissões: o padrão de cada
 * perfil, só para consulta, por módulo. O nível de conversas aparece pelo nome
 * (o do Atendente e o do Supervisor vêm das opções da empresa).
 */

import React from "react";
import { Check, Minus } from "lucide-react";

import { i18n } from "../../translate/i18n";
import { groupLabel, permissionTitle, roleLabel, scopeLabel } from "./labels";
import useTeamAccessStyles from "./styles";

const t = (key, options) => i18n.t(`accessControl.${key}`, options);

const RolesTab = ({ catalog }) => {
  const classes = useTeamAccessStyles();
  const defaults = Object.fromEntries(catalog.roles.map((role) => [role, new Set(catalog.defaults[role] || [])]));

  const mark = (role, item) => {
    if (item.scoped) return scopeLabel(catalog.defaultTicketsView[role]);
    return defaults[role].has(item.key) ? (
      <Check size={16} strokeWidth={2} role="img" className={classes.matrixYes} aria-label={t("rolesTab.included")} />
    ) : (
      <Minus size={16} strokeWidth={1.5} role="img" className={classes.matrixNo} aria-label={t("rolesTab.notIncluded")} />
    );
  };

  return (
    <div className={classes.root}>
      <p className={classes.muted}>{t("rolesTab.intro")}</p>
      <div className={`${classes.card} ${classes.matrixScroll}`}>
        <table className={classes.matrix}>
          <thead>
            <tr>
              <th className={classes.matrixHead} scope="col">
                {t("rolesTab.permission")}
              </th>
              {catalog.roles.map((role) => (
                <th key={role} className={`${classes.matrixHead} ${classes.matrixMark}`} scope="col">
                  {roleLabel(role)}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Object.keys(catalog.groups).map((group) => (
              <React.Fragment key={group}>
                <tr>
                  <th className={classes.matrixGroup} colSpan={catalog.roles.length + 1} scope="colgroup">
                    {groupLabel(group)}
                  </th>
                </tr>
                {catalog.permissions
                  .filter((item) => item.group === group)
                  .map((item) => (
                    <tr key={item.key}>
                      <th className={`${classes.matrixCell} ${classes.matrixRowHead}`} scope="row">
                        {permissionTitle(item.key)}
                      </th>
                      {catalog.roles.map((role) => (
                        <td key={role} className={`${classes.matrixCell} ${classes.matrixMark}`}>
                          {mark(role, item)}
                        </td>
                      ))}
                    </tr>
                  ))}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RolesTab;
